import {baseUrl} from'../config';

export const categoryController ={
    GetAllCategories:baseUrl+'/api/category',
   
} 